import {useEffect} from 'react';
import {IPage} from '@brix/shared-frontend';
import {Link as RouterLink} from 'react-router-dom';
import {Box, Card, Container, Divider, Link, Typography} from '@mui/material';
import ForgotPasswordForm from './ForgotPasswordForm';
import Logo from '@admin/components/Logo';

const ForgotPasswordView: React.FC<IPage> = () => {
  useEffect(() => {
    document.title = 'Recover password';
  }, []);

  return (
    <Box
      component="main"
      sx={{
        backgroundColor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <Container
        maxWidth="sm"
        sx={{
          py: {
            xs: '60px',
            md: '120px',
            lg: '60px',
          },
        }}
      >
        <Card elevation={16} sx={{p: 4}}>
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <RouterLink to="/">
              <Logo height={80} width={80} />
            </RouterLink>
            <Typography variant="h4">Password Recovery</Typography>
            <Typography color="textSecondary" sx={{mt: 2}} variant="body2">
              Tell us your email so we can send you a reset link
            </Typography>
            <Box
              sx={{
                flexGrow: 1,
                mt: 3,
              }}
            >
              <ForgotPasswordForm />
            </Box>
          </Box>
          <Divider sx={{my: 3}} />
          <Typography color="textSecondary" sx={{mt: 2}} variant="body2">
            Already have a password? &nbsp;
            <Link component={RouterLink} to="/" color="textSecondary" sx={{mt: 1}} variant="body2">
              Sign in
            </Link>
          </Typography>
        </Card>
      </Container>
    </Box>
  );
};

export default ForgotPasswordView;
